import { render, staticRenderFns } from "./BackAndNext.vue?vue&type=template&id=77ffbe2c&scoped=true"
import script from "./BackAndNext.vue?vue&type=script&lang=js"
export * from "./BackAndNext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ffbe2c",
  null
  
)

export default component.exports